import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import Consts from "../../utilities/Consts";
import * as NetworkHelper from "../../utilities/Networkhelper";

import CommonHelper from "../../utilities/CommonHelper";
import { useFormik } from "formik";
import { Toolbar } from "primereact/toolbar";
import { LkCalendar } from "../../components/LkCalendar";
import { BlockUI } from "primereact/blockui";
import { useStateValue } from "../../utilities/StateProvider";
import StringHelper from "../../utilities/StringHelper";
import DropDownHelper from "../../utilities/DropDownHelper";
import { LkDropDown } from "../../components/LkDropDown";
import { Sidebar } from "primereact/sidebar";
import { FaturaBaskiBulkViewReport } from "../statements/FaturaBaskiBulkViewReport";
import { LkTriStateCheckbox } from "../../components/LkTriStateCheckbox";

export const FaturlanmisSiparislerReport = (props) => {
  const { } = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.siparisler;

  const isFirstRender = useRef(true);

  const [{ user, userLanguage }, dispatch] = useStateValue();
  const [count, setCount] = useState(0);
  const [sum, setSum] = useState(0);
  const [datalist, setDatalist] = useState([]);
  const [blocked, setBlocked] = useState(false);
  const [dataTableLoading, setDataTableLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedDatatableItems, setSelectedDatatableItems] = useState([]);
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState(-1);
  const [ddUlke, setddUlke] = useState([]);
  const [labelAtuState, setLabelAtuState] = useState();
  
  const [bulkReportVisible, setBulkReportVisible] = useState(false);
  const dt = useRef(undefined);

  const ddListLascft = [
    { label: cLabels.all, key: null },
    { label: cLabels.yes, key: "1" },
    { label: cLabels.no, key: "0" },
  ];

  const formik = useFormik({
    initialValues: {
      start_date: CommonHelper.firstDateOfPreviousMonth(),
      end_date: CommonHelper.lastDateOfPreviousMonth(),
      country: null,
      cus_atu_no: null
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate: (data) => {
      let errors = {};

      if (StringHelper.isEmpty(data.start_date)) {
        errors.start_date = cLabels.requiredField;

      }
      if (StringHelper.isEmpty(data.end_date)) {
        errors.end_date = cLabels.requiredField;

      }
      setErrors(errors);
      if (Object.keys(errors).length !== 0) {
        CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
      }

      return errors;
    },
    onSubmit: (data) => {
      _list(data, sortField, sortOrder);
    },
  });

  useEffect(() => {
    dispatch({
      type: "SET_PAGE_HEADER",
      pageHeader: cLabels.faturalandirilmis_siparisler_header,
    });
  }, [userLanguage]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      init();
    }
  });
  const init = async () => {
    CommonHelper.setGlobalBlocked(dispatch, true);
    await Promise.all([setddUlke(await DropDownHelper.ulke())])
      .then((values) => {
        _list(formik.values, sortField, sortOrder);
      })
      .catch((error) => {
        CommonHelper.handleCatch(error);
      });
    CommonHelper.setGlobalBlocked(dispatch, false);
  };
  const _list = async (_filters = formik.values, _sortField = sortField, _sortOrder = sortOrder) => {
    try {
      setDataTableLoading(true);
      setSortField(_sortField);
      setSortOrder(_sortOrder);
      let response = await NetworkHelper.call_web_service(baseUrl.list_for_faturalanmis_siparisler, {
        country: _filters.country,
        start_date: _filters.start_date,
        end_date: _filters.end_date,
        orderByField: _sortField,
        cus_atu_no: _filters.cus_atu_no,
        orderBy: _sortOrder === 1 ? "ASC" : "DESC",
      });
      setDatalist(response.datalist);
      setSelectedDatatableItems([]);
      let _sum = 0;
      response.datalist.forEach(element => {
        _sum += element.s_g_toplam;
      });
      setCount(response.datalist.length);
      setSum(CommonHelper.toFixedCurrency(_sum));
    } catch (error) {
      console.log("._onList.catch", error);
      CommonHelper.handleCatch(error);
    } finally {
      setDataTableLoading(false);
    }
  };

  const rightContents = (
    <div className="table-header">
      <Button icon="pi pi-search" label={cLabels.search} className="p-mr-2" form="my-form" onSubmit={() => formik.handleSubmit()} />
      <Button
        className="p-mr-2"
        label={cLabels.clear}
        icon="pi pi-refresh"
        onClick={() => {
          formik.resetForm();
          setDatalist([]);
          setSelectedDatatableItems([]);
          setCount(0);
          setSum(0);
        }}
      />
    </div>
  );

  const header = (
    <div className="table-header">
      {cLabels.kapali_siparisler_header}
      {user.user_level == 1 && (
        <Button
          type="button"
          icon="pi pi-file-pdf"
          label={cLabels.fatura_goruntule}
          className="p-button-danger"
          disabled={selectedDatatableItems.length === 0}
          onClick={() => setBulkReportVisible(true)}
        />
      )}
    </div>
  );

  let footerGroup = (
    <div>
      {`${Consts.localizedStrings.totalCount}: ${count} - ${Consts.localizedStrings.TotalSum}: ${sum}`}
    </div>
  );

  return (
    <div className="content-section implementation datatable-filter-demo">
      <BlockUI blocked={blocked} fullScreen />

      <div className=" p-fluid p-formgrid  grid">
        <div className="col-12 md:col-9">
          <div className="card" >
            <form id="my-form" onSubmit={formik.handleSubmit} style={{ marginLeft: "20px" }}>
              <div className="p-fluid p-formgrid  grid" style={{ alignItems: 'center' }}>
                <div className="p-field  col-3">
                  <label>{cLabels.start_date + '(' + cLabels.f_tarih + ')'}</label>
                  <LkCalendar id="start_date" formik={formik} />
                </div>
                <div className="p-field  col-3">
                  <label>{cLabels.end_date + '(' + cLabels.f_tarih + ')'}</label>
                  <LkCalendar id="end_date" formik={formik} />
                </div>
                <div className="p-field  col-3">
                  <label >{cLabels.country_code}</label>
                  <LkDropDown options={ddUlke} id="country" formik={formik} />
                </div>
                <div className="p-field  col-3">
                  <label htmlFor="cus_atu_no">{labelAtuState}</label>
                  <LkTriStateCheckbox id="cus_atu_no" formik={formik} label_all={cLabels.cus_atu_no + '+' + cLabels.all} set_label={setLabelAtuState} label_pasive={cLabels.cus_atu_no + '+' + cLabels.no} label_aktive={cLabels.cus_atu_no + '+' + cLabels.yes} />
                </div>
              </div>
            </form>
            <div className="clear">
              <Toolbar right={rightContents} />
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="card">
        <DataTable
          reorderableColumns
          header={header}
          value={datalist}
          dataKey={"id"}
          id="idx"
          rowHover
          ref={dt}
          className="p-datatable-sm"
          emptyMessage={cLabels.datatable_empty_mesaage}
          loading={dataTableLoading}
          stripedRows
          resizableColumns
          scrollable
          scrollHeight='calc(100vh - 450px)'
          footer={footerGroup}
          selection={selectedDatatableItems}
          filterDisplay="row"
          onSelectionChange={(e) => setSelectedDatatableItems(e.value)}
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={(event) => _list(formik.values, event.sortField, event.sortOrder)}
        >
          <Column selectionMode="multiple" exportable={false} style={{ maxWidth: "3rem" }} />
          <Column field="cus_name" header={cLabels.cus_name} headerStyle={{ width: "15rem" }} sortable />
          <Column field="cus_surname" header={cLabels.cus_surname} headerStyle={{ width: "15rem" }} sortable />
          <Column field="cus_id" header={cLabels.cus_code} sortable />
          <Column field="f_no" header={cLabels.f_no} sortable />
          <Column field="f_tarih" header={cLabels.f_tarih} body={(rowData) => CommonHelper.dateBodyTemplate(rowData, "f_tarih")} dataType="date" sortable />
          <Column field="s_g_toplam" header={cLabels.s_g_toplam} dataType="numeric" body={(rowData) => CommonHelper.toFixedCurrencyBold(rowData.s_g_toplam)} sortable />
          <Column field="per_name" header={cLabels.per_name} sortable />
          <Column field="cus_firm" header={cLabels.firma} headerStyle={{ width: "15rem" }} sortable />
          <Column field="cus_atu_no" header={cLabels.cus_atu_no} headerStyle={{ width: "15rem" }} sortable />
          <Column
            field="s_lastschrift"
            header={cLabels.s_lastschrift}
            headerStyle={{ width: "15rem" }}
            body={(rowData) => {
              return DropDownHelper.findLabelByKeyNoAsync(ddListLascft, rowData["s_lastschrift"]);
            }}
            sortable
          />
          <Column field="country" header={cLabels.ulke} headerStyle={{ width: "15rem" }} sortable />
        </DataTable>

        <Sidebar
          visible={bulkReportVisible}
          position="right" dismissable={false} className="p-sidebar-lg" closeOnEscape={false}
          onHide={() => setBulkReportVisible(false)}
        >
          {bulkReportVisible && (
            <FaturaBaskiBulkViewReport
              siparisler={selectedDatatableItems}
              onCloseSidebar={() => {
                setBulkReportVisible(false);
              }}
            />
          )}
        </Sidebar>
      </div>
    </div>
  );
};
